module.exports = __webpack_public_path__ + "static/media/ergo-logo.4c295972.svg";